<template>
    <div class="suggest" :class="{'d-none': !visible || !id}">
        <div class="suggest__overlay"></div>

        <div class="suggest__modal">
            <div class="suggest__offers" v-if="offers && offers.length > 0 && step === 1">
                <div class="suggest__heading">
                    <p class="suggest__title">Votre produit a bien été ajouté au <span>panier</span>.</p>
                    <p class="suggest__subtitle">
                    Nous vous conseillons avec cette prestation :
                    </p>
                </div>
                <div class="suggest__content mb-4">
                    <div class="suggest__content-item" v-for="offer in offers"
                        @click="select(offer.prestation_discount.id, 'offers')"
                         :key="'offer-'+offer.id"
                         :class="{'suggest__content-item--active': selected.offers.findIndex(el => el.id === offer.prestation_discount.id) !== -1}">
                        <div class="suggest__content-item-header">
                            <div class="suggest__content-item-badges">
                                <span class="suggest__content-item-badge" v-if="getCommercialTime(offer.prestation_discount)">
                                    <span class="suggest__content-item-badge-dot"></span>
                                    {{ getCommercialTime(offer.prestation_discount) }} min
                                </span>
                                <span class="suggest__content-item-discount-badge" v-if="hasOfferDiscount(offer)">
                                    {{ getOfferDiscountLabel(offer) }}
                                </span>
                            </div>
                            <span class="suggest__content-item-check" aria-hidden="true"></span>
                            <img v-if="getImage(offer.prestation_discount)" :alt="offer.prestation_discount?.name"
                                 :src="getImage(offer.prestation_discount)">
                            <div class="suggest__content-item-placeholder" v-else>
                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M27.5 6.5C18.8 6.8 10.4 11 7.2 18.5C5.5 22.4 6 26.3 6.7 28.4C8.8 29 12.7 29.5 16.6 27.8C24.1 24.6 28.2 16.2 27.5 6.5Z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8 26C12.5 19.5 17.8 15 24.5 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
                                </svg>
                                <span>{{ offer.prestation_discount?.name || 'Offre complémentaire' }}</span>
                            </div>
                        </div>
                        <div class="suggest__content-item-content">
                            <span class="suggest__content-item-type">Offre supplémentaire</span>
                            <h2 v-if="offer.prestation_discount?.name">{{ offer.prestation_discount?.name }}</h2>
                            <h3 v-if="offer.prestation_discount?.subtitle">{{
                                    offer.prestation_discount?.subtitle
                                }}</h3>
                            <div class="suggest__content-item-content-info">
                                <p class="suggest__content-item-content-info-price">
                                    <span v-if="hasOfferDiscount(offer)" class="suggest__content-item-final-price">
                                        <span>Prix final :</span>
                                        <del>{{ formatOfferPrice(getOfferBasePrice(offer)) }}€</del>
                                        <b>{{ formatOfferPrice(getOfferFinalPrice(offer)) }}€</b>
                                    </span>

                                    <b v-else>{{ formatOfferPrice(getOfferBasePrice(offer)) }}€</b>
                                </p>
                                <div class="suggest__content-item-content-info-detail">
                                    <a class="suggest__content-item-content-info-detail-more" href="javascript:" @click.stop.prevent="toggleDetail">En
                                        savoir plus <span aria-hidden="true">→</span></a>
                                    <button class="suggest__content-item-action" type="button">Choisir</button>
                                    <div class="suggest__detail-popover" @click.stop>
                                        <button class="suggest__detail-close" type="button" aria-label="Fermer" @click.stop.prevent="closeDetail">×</button>
                                        <p class="suggest__detail-title">Description</p>
                                        <div class="suggest__detail-body" v-html="offer.prestation_discount.description || 'Pas de description pour ce soin.'"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="suggest__footer" :class="{'suggest__footer--multiple': ifPrevStep, 'suggest__footer--single': !ifPrevStep}">
                    <button class="suggest__nav-button suggest__nav-button--previous" @click="prev()" v-if="ifPrevStep">
                        <span class="suggest__nav-arrow suggest__nav-arrow--left" aria-hidden="true">
                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 1L1 6M1 6L6 11M1 6H17" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        Précédent
                    </button>
                    <button class="suggest__nav-button suggest__nav-button--next" @click="next()" v-if="ifNextStep">
                        Suivant
                        <span class="suggest__nav-arrow" aria-hidden="true">
                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 1L17 6M17 6L12 11M17 6H1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </button>
                    <button class="suggest__nav-button suggest__nav-button--validate" @click="validate()" v-else>
                        Continuer
                        <span class="suggest__nav-arrow" aria-hidden="true">
                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 1L17 6M17 6L12 11M17 6H1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        <span class="suggest__loader" v-show="loading"></span>
                    </button>
                </p>
            </div>
            <div class="suggest--options" v-if="options && options.length > 0 && step === 2">
                <div class="suggest__heading">
                    <p class="suggest__title">Poussons plus loin votre <span>expérience</span></p>
                    <p class="suggest__subtitle">
                        Agrémentez votre prestation avec ses options proposées.
                    </p>
                </div>
                <div class="suggest__content mb-4">
                    <div class="suggest__content-item" v-for="option in options"
                         @click="select(option.item.id, 'options', option.type, option.item?.quantity)"
                         :key="'option-'+option.id"
                         :class="{'suggest__content-item--active': selected.options.findIndex(el => el.id === option.item.id) !== -1}">
                        <div class="suggest__content-item-header">
                            <span class="suggest__content-item-badge" v-if="option.type === 'prestation' && getCommercialTime(option.item)">
                                <span class="suggest__content-item-badge-dot"></span>
                                {{ getCommercialTime(option.item) }} min
                            </span>
                            <span class="suggest__content-item-check" aria-hidden="true"></span>
                            <img v-if="getImage(option.item)" :alt="option.item?.name"
                                 :src="getImage(option.item)">
                            <div class="suggest__content-item-placeholder" v-else>
                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M27.5 6.5C18.8 6.8 10.4 11 7.2 18.5C5.5 22.4 6 26.3 6.7 28.4C8.8 29 12.7 29.5 16.6 27.8C24.1 24.6 28.2 16.2 27.5 6.5Z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8 26C12.5 19.5 17.8 15 24.5 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
                                </svg>
                                <span>{{ option.item?.name || 'Option proposée' }}</span>
                            </div>
                        </div>
                        <div class="suggest__content-item-content">
                            <span class="suggest__content-item-type">{{ option.type === 'prestation' ? 'Option soin' : 'Option produit' }}</span>
                            <h2 v-if="option.item?.name">{{ option.item?.name }}</h2>

                            <div class="suggest__content-item-content-info">
                                <p class="suggest__content-item-content-info-price">
                                    <b>{{
                                            option.item?.price - (option.item?.discount_price || 0)
                                        }}€</b>
                                </p>

                                <div class="suggest__content-item-content-info-detail">
                                    <a class="suggest__content-item-content-info-detail-more" href="javascript:" @click.stop.prevent="toggleDetail">
                                        En savoir plus <span aria-hidden="true">→</span>
                                    </a>
                                    <button class="suggest__content-item-action" type="button"
                                            v-if="option.type === 'prestation' || option.item?.quantity > 0">Choisir
                                    </button>
                                    <button class="suggest__content-item-action suggest__content-item-action--disabled" type="button" disabled v-else>Indisponible</button>
                                    <div class="suggest__detail-popover" @click.stop>
                                        <button class="suggest__detail-close" type="button" aria-label="Fermer" @click.stop.prevent="closeDetail">×</button>
                                        <p class="suggest__detail-title">Description</p>
                                        <div class="suggest__detail-body" v-html="option.item?.description || 'Pas de description pour ce soin.' "></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="suggest__footer" :class="{'suggest__footer--multiple': ifPrevStep, 'suggest__footer--single': !ifPrevStep}">
                    <button class="suggest__nav-button suggest__nav-button--previous" @click="prev()" v-if="ifPrevStep">
                        <span class="suggest__nav-arrow suggest__nav-arrow--left" aria-hidden="true">
                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 1L1 6M1 6L6 11M1 6H17" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        Précédent
                    </button>
                    <button class="suggest__nav-button suggest__nav-button--next" @click="next()" v-if="ifNextStep">
                        Suivant
                        <span class="suggest__nav-arrow" aria-hidden="true">
                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 1L17 6M17 6L12 11M17 6H1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </button>
                    <button class="suggest__nav-button suggest__nav-button--validate" @click="validate()" v-else>
                        Continuer
                        <span class="suggest__nav-arrow" aria-hidden="true">
                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 1L17 6M17 6L12 11M17 6H1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        <span class="suggest__loader" v-show="loading"></span>
                    </button>
                </p>
            </div>
            <div class="suggest--products" v-if="products && products.length > 0 && step === 3">
                <div class="suggest__heading">
                    <p class="suggest__title">Poussons plus loin votre <span>expérience</span></p>
                    <p class="suggest__subtitle">
                        Souhaitez-vous mettre ces produits de côté pour votre arrivée ?
                    </p>
                </div>
                <div class="suggest__content mb-4">
                    <div class="suggest__content-item" v-for="item in products"
                         @click="select(item.product.id, 'products', null, item.product?.quantity)"
                         :key="'product-'+item.id"
                         :class="{'suggest__content-item--active': selected.products.findIndex(el => el.id === item.product.id) !== -1}">
                        <div class="suggest__content-item-header">
                            <span class="suggest__content-item-badge">
                                <span class="suggest__content-item-badge-dot"></span>
                                Produit
                            </span>
                            <span class="suggest__content-item-check" aria-hidden="true"></span>
                            <img v-if="getImage(item.product)" :alt="item.product?.name"
                                 :src="getImage(item.product)">
                            <div class="suggest__content-item-placeholder" v-else>
                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M27.5 6.5C18.8 6.8 10.4 11 7.2 18.5C5.5 22.4 6 26.3 6.7 28.4C8.8 29 12.7 29.5 16.6 27.8C24.1 24.6 28.2 16.2 27.5 6.5Z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8 26C12.5 19.5 17.8 15 24.5 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
                                </svg>
                                <span>{{ item.product?.name || 'Produit conseillé' }}</span>
                            </div>
                        </div>

                        <div class="suggest__content-item-content">
                            <span class="suggest__content-item-type">Produit conseillé</span>
                            <h2 v-if="item.product?.name">{{ item.product?.name }}</h2>

                            <div class="suggest__content-item-content-info">
                                <p class="suggest__content-item-content-info-price">
                                    <b>{{
                                            item.product?.price - (item.product?.discount_price || 0)
                                        }}€</b>
                                </p>

                                <div class="suggest__content-item-content-info-detail">
                                    <a class="suggest__content-item-content-info-detail-more" href="javascript:" @click.stop.prevent="toggleDetail">
                                        En savoir plus <span aria-hidden="true">→</span>
                                    </a>
                                    <button class="suggest__content-item-action" type="button" v-if="item.product?.quantity > 0">Choisir</button>
                                    <button class="suggest__content-item-action suggest__content-item-action--disabled" type="button" disabled v-else>Indisponible</button>
                                    <div class="suggest__detail-popover" @click.stop>
                                        <button class="suggest__detail-close" type="button" aria-label="Fermer" @click.stop.prevent="closeDetail">×</button>
                                        <p class="suggest__detail-title">Description</p>
                                        <div class="suggest__detail-body"
                                             v-html="item.product?.description || 'Pas de description pour cet article.' "></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="suggest__footer" :class="{'suggest__footer--multiple': ifPrevStep, 'suggest__footer--single': !ifPrevStep}">
                    <button class="suggest__nav-button suggest__nav-button--previous" @click="prev()" v-if="ifPrevStep">
                        <span class="suggest__nav-arrow suggest__nav-arrow--left" aria-hidden="true">
                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 1L1 6M1 6L6 11M1 6H17" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        Précédent
                    </button>
                    <button class="suggest__nav-button suggest__nav-button--next" @click="next()" v-if="ifNextStep">
                        Suivant
                        <span class="suggest__nav-arrow" aria-hidden="true">
                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 1L17 6M17 6L12 11M17 6H1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </button>
                    <button class="suggest__nav-button suggest__nav-button--validate" @click="validate()" v-else>
                        Continuer
                        <span class="suggest__nav-arrow" aria-hidden="true">
                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 1L17 6M17 6L12 11M17 6H1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        <span class="suggest__loader" v-show="loading"></span>
                    </button>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";

export default {
    data: () => ({
        loading: false,
        refresh: null,
        id: null,
        step: 1,
        offers: [],
        options: [],
        products: [],
        selected: {
            offers: [],
            options: [],
            products: []
        },
        visible: false,
    }),
    props: {
        goToCart: Boolean,
    },
    computed: {
        ifNextStep()
        {
            let step = this.step + 1;
            if (step === 1 && this.offers.length === 0) step++;
            if (step === 2 && this.options.length === 0) step++;

            if (step === 1 && this.offers.length > 0) return true;
            if (step === 2 && this.options.length > 0) return true;
            if (step === 3 && this.products.length > 0) return true;
            return false;
        },
        ifPrevStep()
        {
            let step = this.step - 1;
            if (step === 3 && this.products.length === 0) step--;
            if (step === 2 && this.options.length === 0) step--;

            if (step === 1 && this.offers.length > 0) return true;
            if (step === 2 && this.options.length > 0) return true;
            if (step === 3 && this.products.length > 0) return true;
            return false;
        }
    },
    mounted()
    {
        this.click = this.click.bind(this);
        document.addEventListener('click', this.click);
    },

    beforeDestroy()
    {
        document.removeEventListener('click', this.click);
    },

    methods: {
        click(evt)
        {
            if (evt && evt.target && evt.target.closest('[data-add-to-cart]')) {
                const target = evt.target.closest('[data-add-to-cart]');
                if (!target) return;

                this.id = parseInt(target.getAttribute('data-add-to-cart')) || null;
                this.getOffers();
            } else if (evt && evt.target && evt.target.closest('.suggest__content-item-content-info-detail-more')) {
                evt.preventDefault();
                evt.stopPropagation();
                evt.target.closest('.suggest__content-item-content-info-detail').classList.toggle('suggest__content-item-content-info-detail--active');
            } else if (evt && evt.target && evt.target.closest('.suggest__detail-close')) {
                evt.preventDefault();
                evt.stopPropagation();
                evt.target.closest('.suggest__content-item-content-info-detail')?.classList.remove('suggest__content-item-content-info-detail--active');
            } else {
                document.querySelectorAll('.suggest__content-item-content-info-detail--active').forEach(el => el.classList.remove('suggest__content-item-content-info-detail--active'));
            }
        },

        toggleDetail(evt)
        {
            const detail = evt?.target?.closest('.suggest__content-item-content-info-detail');
            if (!detail) return;

            document.querySelectorAll('.suggest__content-item-content-info-detail--active').forEach(el => {
                if (el !== detail) el.classList.remove('suggest__content-item-content-info-detail--active');
            });

            detail.classList.toggle('suggest__content-item-content-info-detail--active');
        },

        closeDetail(evt)
        {
            evt?.target?.closest('.suggest__content-item-content-info-detail')?.classList.remove('suggest__content-item-content-info-detail--active');
        },

        getOffers()
        {
            if (!this.id) return;

            axios.post(`/api/options`, {'id': this.id}).then(response => {
                if (response.status === 200 && response.data) {
                    this.offers = response.data.offers || [];
                    this.options = response.data.options || [];
                    this.products = response.data.products || [];
                    this.selected = {
                        offers: [],
                        options: [],
                        products: []
                    };

                    if (this.offers.length > 0) {
                        this.step = 1;
                        this.visible = true;
                    } else if (this.options.length > 0) {
                        this.step = 2;
                        this.visible = true;
                    } else if (this.products.length > 0) {
                        this.step = 3;
                        this.visible = true;
                    }
                }
            });
        },

        getImage(item)
        {
            if (item?.image) {
                return item.image;
            }

            if (item?.img1) {
                return item.img1;
            }

            if (item?.img2) {
                return item.img2;
            }

            if (item?.img3) {
                return item.img3;
            }

            return null;
        },

        getCommercialTime(item)
        {
            const commercialTime = parseInt(item?.commercial_time || item?.commercialTime || item?.duration);
            if (commercialTime > 0) return commercialTime;

            const nameTime = `${item?.name || ''}`.match(/(\d+)\s*(?:min|')/i);
            return nameTime ? parseInt(nameTime[1]) : null;
        },

        hasOfferDiscount(offer)
        {
            return Number(offer?.discount_amount || 0) !== 0;
        },

        getOfferBasePrice(offer)
        {
            return Number(offer?.prestation_discount?.price || 0) - Number(offer?.prestation_discount?.discount || 0);
        },

        getOfferFinalPrice(offer)
        {
            const basePrice = this.getOfferBasePrice(offer);
            const discountAmount = Number(offer?.discount_amount || 0);

            if (offer?.discount_type === 'fixed') {
                return Math.max(0, basePrice - discountAmount);
            }

            if (offer?.discount_type === 'percentage') {
                return Math.max(0, basePrice * (1 - discountAmount / 100));
            }

            return basePrice;
        },

        getOfferDiscountLabel(offer)
        {
            const discountAmount = this.formatOfferPrice(Number(offer?.discount_amount || 0));
            return offer?.discount_type === 'percentage' ? `-${discountAmount}%` : `-${discountAmount}€`;
        },

        formatOfferPrice(value)
        {
            const rounded = Math.round(Number(value || 0) * 100) / 100;
            return Number.isInteger(rounded)
                ? `${rounded}`
                : rounded.toFixed(2).replace('.', ',');
        },

        select(id, type, params = null, quantity = null)
        {
            const index = this.selected[type].findIndex(el => el.type === type && el.id === id);
            if (index !== -1) {
                this.selected[type].splice(index, 1);
                return;
            }

            if (quantity !== null && quantity <= 0) return;

            this.selected[type].push({type: type, id: id, params: params});
        },

        next()
        {
            if (this.step < 3) {
                this.step++;
            }

            if (this.step === 1 && this.offers.length === 0) this.step++;
            if (this.step === 2 && this.options.length === 0) this.step++;
            if (this.step === 3 && this.products.length === 0) this.validate();
            console.log(this.step);
        },

        prev()
        {
            if (this.step > 1) {
                this.step--;
            }

            if (this.step === 3 && this.products.length === 0) this.step--;
            if (this.step === 2 && this.options.length === 0) this.step--;
        },

        async validate()
        {
            if (this.loading) return;

            this.loading = true;
            for (let key in this.selected) {
                let url = null;
                let data = null;

                switch (key) {
                    case 'offers':
                        if (this.selected[key].length > 0) {
                            url = `/soin/${this.id}/addMultipleToBasket`;
                            data = new FormData();
                            data.append('prestation', this.id);
                            this.selected[key].forEach(item => data.append('additionnal_offers[]', item.id));
                        }
                        break;
                    case 'options':
                        if (this.selected[key].length > 0) {
                            url = `/soin/reservation/option`;
                            data = new FormData();
                            this.selected[key].forEach(item => {
                                let type = item.params === 'prestation' ? 'prestations' : 'products';
                                data.append(`options[${this.id}][${type}][]`, item.id)
                            });
                        }
                        break;
                    case 'products':
                        if (this.selected[key].length > 0) {
                            url = `/soin/reservation/recommandation`;
                            data = new FormData();
                            this.selected[key].forEach(item => data.append(`selected_products[${this.id}][]`, item.id));
                        }
                        break;
                }

                if (url !== null) {
                    console.log(url, key)
                    try {
                        await axios.post(url, data);
                    } catch (error) {
                        console.log(error);
                    }
                }
            }

            if (this.goToCart) {
                window.location.href = '/panier';
            } else {
                if (this.refresh) clearTimeout(this.refresh);
                this.refresh = setTimeout(() => $("#header").load("/ #header"), 500);
                this.loading = false;
                this.visible = false;
            }
        }
    }
}
</script>
